import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
// import { config } from '../config';
import { url } from "../env";

export const AuthContext = React.createContext();

export function AuthProvider({ children }) {
  const [authInfo, setAuthInfo] = useState({
    token: null,
    type: null,
    loading: true,
    user: {},
    isAuth : false
  });

  function resetInfo() {
    setAuthInfo((prev) => {
      return {
        token: null,
        type: null,
        loading: false,
        isAuth : false,
      };
    });
  }

  function appendInfo(obj) {
    setAuthInfo((prev) => {
      return {
        ...prev,
        ...obj,
      };
    });
  }

  function setAttr(key, val) {
    setAuthInfo((prev) => {
      return {
        ...prev,
        [key]: val,
      };
    });
  }

  function setIdUser(id) {
    // debugger
    setAuthInfo((prev) => {
      return {
        ...prev,
        user: {
          ...prev.user,
          id: id
        }
      }
    })
  }

  function setUser(user) {
    setAuthInfo((prev) => {
      return {
        ...prev,
        user,
        isAuth : true,
        loading: false,
        token: user.token
      }
    })
  }

  function logout() {
    localStorage.removeItem("token");

    resetInfo();
  }



  useEffect(() => {
    let token = localStorage.getItem("token");

    if (token) {
      axios
        .post(
          `${url}/checkSession`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            setAuthInfo((prev) => {
              return {
                ...prev,
                user: {
                  ...prev.user,
                  ...res.data.user, // Mantener las propiedades existentes en user y agregar nuevas
                },
                token: token,
                type: res.data.type,
                loading: false,
                isAuth : true
              };
            });
          }
        })

        .catch((e) => {
          console.log(e);
          // Token inválido / cuenta desactivada / cuenta eliminada —
          // limpiar el estado para forzar nuevo login.
          const status = e?.response?.status;
          if (status === 401 || status === 403) {
            localStorage.removeItem("token");
            resetInfo();
          }
        })
        .finally(() => {
          setAttr("loading", false);
        });
    } else {
      setAttr("loading", false);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{ authInfo, setAuthInfo, resetInfo, appendInfo, setAttr, setIdUser, setUser,logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}
